import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TitleRequestPictureService {

  titilePicture = new Subject<any>();
  constructor() { }
  
  setTitle(titilePicture: any) {
    localStorage.setItem('titilePicture',  JSON.stringify(titilePicture));
    this.titilePicture.next(titilePicture);
  }

  getTitle(): Observable<any> {
    return this.titilePicture.asObservable();
  }
}
